<template>
  <div class="page-examine">
    <!-- <resource-menu :menu="menu" @menuChange="onMenuChange"></resource-menu> -->
    <div v-if="!detailShow" class="examine-content">
      <div class="top-line">
        <div class="small-button" @click="toBack()">返回</div>
        <span class="title">待审核资源</span>
      </div>
      <div class="examine">
        <div v-if="role == 3" class="school-role">
          <el-button
            style="margin-right: 20px; width: 120px"
            :class="{ 'school-select': schoolRange == 0 }"
            @click="selectSchoolRange(0)"
            >平台可见</el-button
          >
          <el-button
            style="width: 120px"
            :class="{ 'school-select': schoolRange == 1 }"
            @click="selectSchoolRange(1)"
            >园内资源</el-button
          >
        </div>
        <el-table
          :data="data"
          style="width: 100%; margin-bottom: 10px"
          :height="tableHeight"
        >
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">{{
              scope.$index + 1 + (pageNum - 1) * 10
            }}</template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="资源标题"
            width="width"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            prop="tag"
            label="资源标签"
            width="width"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="tag"
            label="资源标签"
            width="width"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-for="(item, index) in scope.row.tag"
                :key="item"
                :value="item"
                >{{ index > 0 ? ' / ' : '' }}{{ item }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="文件类型"
            width="width"
            align="center"
          >
            <template slot-scope="scope">
              {{ getFileType(scope.row.urls) }}</template
            >
          </el-table-column>
          <el-table-column
            prop="author"
            label="作者"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="group1_name"
            label="关联图书"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="group2_name"
            label="主题"
            width="width"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            :prop="role == 1 ? 'verify1_at' : 'created_at'"
            :label="role == 1 ? '校级提交时间' : '提交时间'"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="updated_at"
            label="更新时间"
            width="width"
            align="center"
          ></el-table-column> -->
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <div class="small-button" @click="toExamine(scope.row)">
                  {{ menuStatus == 1 ? '审核' : '查看' }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="total"
          class="pagination"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>

    <div v-if="noPassShow" class="no-pass">
      <div class="no-pass-content">
        <div class="no-pass-close" @click="closeNoPass()"></div>
        <div class="no-pass-title">请填写驳回原因</div>
        <el-input
          class="no-pass-textarea"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 5 }"
          placeholder="请输入内容"
          v-model="noPassReason"
        >
        </el-input>
        <div class="no-pass-btn" @click="examineNoPass()">确认驳回</div>
      </div>
    </div>

    <div v-if="passShow && role == 1" class="pass">
      <div class="pass-content">
        <div class="no-pass-close" @click="closePass()"></div>
        <div class="pass-title">请确认是否推荐该资源</div>
        <div class="pass-btns">
          <div
            class="pass-btn"
            style="margin-right: 40px"
            @click="examinePass(2)"
          >
            推荐并发布
          </div>
          <div class="pass-btn" @click="examinePass(3)">直接发布</div>
        </div>
      </div>
    </div>

    <div v-if="passShow && role == 3" class="no-pass">
      <div class="no-pass-content">
        <div class="no-pass-close" @click="closePass()"></div>
        <div class="no-pass-title">请选择发布目录</div>
        <div class="pass-line">
          <div class="pass-line-title">一级目录：</div>
          <el-select
            v-model="mulu1Value"
            clearable
            placeholder="选择目录"
            @change="selectGroup()"
          >
            <el-option
              v-for="item in mulu1List"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="pass-line">
          <div class="pass-line-title">一级目录：</div>
          <el-select v-model="mulu2Value" clearable placeholder="选择目录">
            <el-option
              v-for="(item, index) in mulu2List"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="no-pass-btn" @click="examinePass(1)">确认通过</div>
      </div>
    </div>

    <!-- 详情 -->
    <resource-detail
      :show="detailShow"
      @onReturn="detailShow = false"
      :detailData="detailData"
      detailType="2"
      :examineRole="role"
      :examineStatus="menuStatus"
      :examineRange="schoolRange"
      @toNoPass="toNoPass"
      @toPass="toPass"
    ></resource-detail>
  </div>
</template>

<script>
import { getFileType } from '@/utils/utils.js'
import { findResource, verify, group, resDetail } from '@/api/api.js'
import resourceMenu from '../../components/resourceMenu.vue'
import ResourceDetail from '../../components/resourceDetail.vue'

export default {
  components: { resourceMenu, ResourceDetail },
  name: 'Examine',
  data: () => ({
    menu: ['待审核资源', '已审核资源', '驳回记录'],
    tableHeight: 'calc(100vh - 340px)',
    data: [], // 审核列表
    pageNum: 1, // 审核列表页码
    total: 0, // 审核列表总数

    role: 0, // 身份 1超管 2老师 3学校
    menuStatus: 1, // 审核状态 1待审核 0已通过 -1驳回
    schoolRange: 0, // 校内资源审核 0平台可见 1校内资源(学校端)
    detailShow: false, // 审核资源详情
    detailData: {}, // 资源详情

    noPassShow: false, // 审核不通过弹框
    noPassReason: '', // 审核不通过原因
    passShow: false, // 审核通过弹框
    mulu1List: [],
    mulu1Value: '',
    mulu2List: [],
    mulu2Value: '',
  }),
  async mounted() {
    let user = JSON.parse(localStorage.getItem('yey-user'))
    if (user.role == 'admin') {
      this.role = 1
      setTimeout(() => {
        this.tableHeight = 'calc(100vh - 280px)'
      }, 0)
    }
    if (user.role == 'teacher') {
      this.role = 2
    }
    if (user.role == 'school') {
      this.role = 3
    }
    this.refresh()
  },
  methods: {
    getFileType,
    toBack() {
      // window.history.go(-1)
      this.$router.back()
    },
    selectSchoolRange(range) {
      this.schoolRange = range
      this.refresh()
    },
    onMenuChange(status) {
      if (status == '待审核资源') {
        this.menuStatus = 1
      }
      if (status == '已审核资源') {
        this.menuStatus = 0
      }
      if (status == '驳回记录') {
        this.menuStatus = -1
      }
      this.detailShow = false
      this.schoolRange = 0
      this.refresh()
    },
    refresh() {
      let data = { page: this.pageNum, status: this.menuStatus }
      if (this.role == 3) {
        data.range = this.schoolRange
      }
      findResource(data).then((res) => {
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    pageChange(e) {
      console.log('paginationChage', e)
      this.pageNum = e
      this.refresh()
    },

    toExamine(item) {
      // this.detailData = item
      // this.detailShow = true
      resDetail(item.id).then((res) => {
        if (res.data.code == 0) {
          this.detailData = res.data.data
          this.detailShow = true
        }
      })
    },

    toNoPass() {
      this.noPassShow = true
    },
    closeNoPass() {
      this.noPassShow = false
    },
    examineNoPass() {
      if (!this.noPassReason) {
        this.$message.error('请先填写驳回原因!')
        return
      }

      // describe
      let data = {
        id: this.detailData.id,
        val: 0,
        describe: this.noPassReason,
      }
      console.log('data', data)
      verify(data).then((res) => {
        console.log('verify', res)
        this.noPassReason = ''
        this.noPassShow = false
        this.detailShow = false
        this.refresh()
      })
    },

    toPass() {
      console.log('this.detailData', this.detailData.range)
      // if (this.role == 3 && this.detailData.range == 0) {
      if (this.role == 3) {
        let data = {
          id: this.detailData.id,
          val: 1,
        }
        verify(data).then((res) => {
          console.log('verify', res)
          this.$message({
            message: '已通过',
            type: 'success',
          })
          this.passShow = false
          this.detailShow = false
          this.refresh()
        })
        return
      }
      this.examinePass(3)
      // group().then((res) => {
      //   console.log('group1', res)
      //   this.mulu1List = res.data.data
      // })
      // this.mulu1Value = ''
      // this.mulu2Value = ''
      // this.passShow = true
    },
    selectGroup() {
      console.log('mulu1Value', this.mulu1Value)
      group({ pid: this.mulu1Value }).then((res) => {
        console.log('group2', res)
        this.mulu2List = res.data.data
        this.mulu2Value = ''
      })
    },
    closePass() {
      this.passShow = false
    },
    examinePass(type) {
      console.log('type', type)
      let data = {
        id: this.detailData.id,
        val: 1,
      }
      if (type == 2) {
        data.is_gftj = 1
        // data.is_yzzy = 0
      }
      if (type == 3) {
        data.is_gftj = 0
        // data.is_yzzy = 1
      }
      if (type == 1) {
        if (!this.mulu1Value || !this.mulu2Value) {
          this.$message.error('请先选择目录!')
          return
        }
        data.group1 = this.mulu1Value
        data.group2 = this.mulu2Value
      }
      console.log('data', data)
      verify(data).then((res) => {
        console.log('verify', res)
        this.$message({
          message: '已通过',
          type: 'success',
        })
        this.passShow = false
        this.detailShow = false
        this.refresh()
      })
      // return
      // this.passShow = false
      // this.detailShow = false
      // this.refresh()
    },
  },
}
</script>

<style lang="less" scoped>
.page-examine {
  display: flex;
  .school-role {
    margin-bottom: 20px;
    .school-select {
      color: #fff;
      background: #27b2fe;
    }
  }

  .examine-content {
    box-sizing: border-box;
    width: 100%;
    padding: 0 20px 0;
    .top-line {
      display: flex;
      height: 81px;
      align-items: center;
    }
    .small-button {
      width: 56px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #00aeff;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #00aeff;
      user-select: none;
      cursor: pointer;
    }
    .title {
      font-size: 18px;
      color: #4d4d4d;
      margin-left: 20px;
    }
  }

  .examine {
    width: 100%;
    height: calc(100vh - 210px);
    padding: 20px;
    background-color: #fff;
    box-sizing: border-box;
    .pagination {
      float: right;
    }
  }

  .pass {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9;
    .pass-content {
      position: fixed;
      top: calc(50vh - 66px);
      left: calc(50vw - 180px);
      width: 360px;
      height: 132px;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      .pass-title {
        padding-top: 25px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #606266;
        line-height: 34px;
        text-align: center;
      }
      .pass-btns {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        .pass-btn {
          width: 77px;
          height: 28px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
          background: #27b2fe;
          border-radius: 100px;
          cursor: pointer;
        }
      }
    }
  }
  .no-pass-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(45deg);
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(-45deg);
    }
  }
  .no-pass {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9;
    .no-pass-content {
      position: fixed;
      top: calc(50vh - 171px);
      left: calc(50vw - 253px);
      width: 506px;
      height: 243px;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
      border-radius: 4px;

      .no-pass-title {
        padding: 11px 0 5px 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 26px;
      }
      .no-pass-textarea {
        width: 474px;
        // height: 121px;
        margin-left: 16px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #dfe6ed;
        box-sizing: border-box;
      }
      .no-pass-btn {
        width: 77px;
        height: 28px;
        margin: 20px auto 0;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        background: #27b2fe;
        border-radius: 100px;
        cursor: pointer;
      }
      .pass-line {
        display: flex;
        align-items: center;
        height: 60px;
        padding-left: 20px;
        .pass-line-title {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
